var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-5 mb-5" },
    [
      !_vm.canEndLabellisationInstruction
        ? _c("b-message", { attrs: { type: "is-info" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "graePage.dossiersLabellisationList.explanations-no-end-possible"
                  )
                ) +
                " "
            )
          ])
        : _c("b-message", { attrs: { type: "is-info" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "graePage.dossiersLabellisationList.explanations-end-possible"
                  )
                ) +
                " "
            )
          ]),
      _vm.canEndLabellisationInstruction &&
      _vm.hasRightsToEndLabellisationInstruction()
        ? _c(
            "div",
            [
              _c(
                "b-button",
                {
                  staticClass: "button is-primary",
                  on: { click: _vm.endLabellisation }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "graePage.dossiersLabellisationList.end-instruction"
                        )
                      ) +
                      " "
                  )
                ]
              ),
              _c("br"),
              _c("br")
            ],
            1
          )
        : _vm._e(),
      _c("TableFilterView", {
        attrs: { columns: _vm.columns, initialFilters: _vm.activeFilters },
        on: {
          "update-active-filters": _vm.updateActiveFilters,
          "update-visible-columns": _vm.updateVisibleColumns,
          "export-csv": _vm.exportLabellisationClotureCsv,
          "export-xls": _vm.exportLabellisationClotureXls
        }
      }),
      _c(
        "b-table",
        {
          ref: _vm.tableRef,
          attrs: {
            striped: _vm.config.isStriped,
            hoverable: _vm.config.isHoverable,
            "debounce-search": _vm.config.searchDebounce,
            "aria-next-label": _vm.config.nextLabel(),
            "aria-previous-label": _vm.config.previousLabel(),
            "aria-page-label": _vm.config.pageLabel(),
            "aria-current-label": _vm.config.currentPageLabel(),
            "per-page": _vm.config.perPage,
            "sticky-header": _vm.config.stickyHeader,
            "current-page": _vm.currentPagedSortedParameter.pageNumber,
            "pagination-position": _vm.config.paginationPosition,
            paginated: "",
            "backend-pagination": "",
            "sort-icon": _vm.config.sortIcon,
            "sort-icon-size": _vm.config.sortIconSize,
            "backend-sorting": "",
            "sort-multiple": "",
            "sort-multiple-data": _vm.buefySortingPriority,
            total: _vm.total,
            data: _vm.projects,
            loading: _vm.isLoading
          },
          on: {
            sort: _vm.onSort,
            "sorting-priority-removed": _vm.sortingPriorityRemoved,
            "page-change": _vm.onPageChange
          }
        },
        [
          _vm._l(_vm.columns, function(column) {
            return [
              _c(
                "b-table-column",
                _vm._b(
                  {
                    key: column.field,
                    attrs: { visible: column.visible !== false },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c("div", [
                                column.field === "codeDepartement"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        props.row["etablissements"].length
                                          ? _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    props.row[
                                                      "etablissements"
                                                    ][0].codeDepartement.replace(
                                                      /^0+/,
                                                      ""
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "ville"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        props.row["etablissements"].length
                                          ? _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    props.row[
                                                      "etablissements"
                                                    ][0].ville
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "etablissement.name"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        props.row["etablissements"]
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                props.row[
                                                  "etablissements"
                                                ].filter(function(o) {
                                                  return o && o.id && o.nom
                                                }),
                                                function(organisme) {
                                                  return _c(
                                                    "div",
                                                    { key: organisme.id },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            organisme.nom
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                column.field ===
                                "etablissement.codeEtablissement"
                                  ? _c("div", [
                                      props.row["etablissements"]
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              props.row[
                                                "etablissements"
                                              ].filter(function(o) {
                                                return o && o.id && o.nom
                                              }),
                                              function(organisme) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      props.row["id"] +
                                                      "_" +
                                                      organisme.codeEtablissement
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          organisme.codeEtablissement
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e()
                                    ])
                                  : _vm._e(),
                                column.field === "projet.nom"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(props.row["nom"]) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "typeDossier"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(props.row.typeDossier)
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "statut"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("StatutDossierTag", {
                                          attrs: {
                                            dossier: props.row,
                                            canSeeInstructionComment: "",
                                            loggedUser: _vm.loggedUser
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                column.field === "natureAireEducative"
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            props.row["natureAireEducative"]
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _vm._e(),
                                column.field === "enseignant.name"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(
                                        props.row["enseignants"].filter(
                                          function(u) {
                                            return u && u.id && u.nom
                                          }
                                        ),
                                        function(utilisateur, i) {
                                          return _c(
                                            "div",
                                            { key: i + "_" + utilisateur.id },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    utilisateur.prenom +
                                                      " " +
                                                      utilisateur.nom
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                                column.field === "structure.name"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        props.row["structures"]
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                props.row["structures"].filter(
                                                  function(o) {
                                                    return o && o.id && o.nom
                                                  }
                                                ),
                                                function(organisme) {
                                                  return _c(
                                                    "div",
                                                    { key: organisme.id },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            organisme.nom
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "referent.name"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(
                                        props.row["referents"].filter(function(
                                          u
                                        ) {
                                          return u && u.id && u.nom
                                        }),
                                        function(utilisateur, i) {
                                          return _c(
                                            "div",
                                            { key: i + "_" + utilisateur.id },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    utilisateur.prenom +
                                                      " " +
                                                      utilisateur.nom
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                                column.field === "dateModification"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                props.row[column.field]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "instructeurs.name"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        props.row["evaluations"]
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                props.row["evaluations"],
                                                function(evaluation) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        evaluation.instructeur
                                                          .id
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            evaluation
                                                              .instructeur
                                                              .prenom +
                                                              " " +
                                                              evaluation
                                                                .instructeur.nom
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "deroule"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.row["evaluationFinale"]
                                                .derouleNote
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "diffusion"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.row["evaluationFinale"]
                                                .adhesionNote
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "enseignements"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.row["evaluationFinale"]
                                                .integrationNote
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "implication"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.row["evaluationFinale"]
                                                .implicationNote
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "commentaires"
                                  ? _c(
                                      "div",
                                      { staticClass: "clickable" },
                                      [
                                        _c(
                                          "LabellisationEvaluationCommentsPopup",
                                          {
                                            attrs: {
                                              projectAnnuel: props.row,
                                              evaluation:
                                                props.row.evaluationFinale,
                                              isFinal: true,
                                              readOnly: true
                                            }
                                          }
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                column.field === "evaluation.mention"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "instruction-pannel.instruction." +
                                                  props.row["evaluationFinale"]
                                                    .mention
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                column.field === "action"
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "buttons" },
                                        [
                                          _c("b-button", {
                                            attrs: {
                                              "icon-left": "eye",
                                              type: "is-link is-outlined",
                                              title: _vm.$t("consult-projet"),
                                              label: _vm.$t("consult")
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.consult(
                                                  $event,
                                                  props.row["projetId"],
                                                  props.row["id"]
                                                )
                                              }
                                            }
                                          }),
                                          _c("b-button", {
                                            attrs: {
                                              "icon-left": "comment-alt",
                                              type: "is-link is-outlined",
                                              title: _vm.$t(
                                                "instructionPage.labellisations.cloture.renvoyer"
                                              ),
                                              label: _vm.$t(
                                                "instructionPage.labellisations.cloture.renvoyer"
                                              ),
                                              disabled: !_vm.hasRightToModify
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.renvoyer(
                                                  $event,
                                                  props.row["id"]
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                column.field === "thematique"
                                  ? _c(
                                      "div",
                                      { staticClass: "clamp" },
                                      _vm._l(props.row[column.field], function(
                                        thematique,
                                        index
                                      ) {
                                        return _c("span", { key: thematique }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "instruction." + thematique
                                                )
                                              )
                                          ),
                                          index !=
                                          props.row[column.field].length - 1
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("virgule"))
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                column.field === "objectsConcretRealisation"
                                  ? _c(
                                      "div",
                                      { staticClass: "clamp" },
                                      _vm._l(props.row[column.field], function(
                                        objet,
                                        index
                                      ) {
                                        return _c("span", { key: objet }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("instruction." + objet)
                                              )
                                          ),
                                          index !=
                                          props.row[column.field].length - 1
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("virgule"))
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                column.field === "milieuGenerique" &&
                                props.row[column.field]
                                  ? _c("div", { staticClass: "clamp" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "instruction." +
                                                props.row[column.field]
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                column.field === "milieuInteretParticulier"
                                  ? _c(
                                      "div",
                                      { staticClass: "clamp" },
                                      _vm._l(props.row[column.field], function(
                                        milieu,
                                        index
                                      ) {
                                        return _c("span", { key: milieu }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("instruction." + milieu)
                                              )
                                          ),
                                          index !=
                                          props.row[column.field].length - 1
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("virgule"))
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                !column.custom
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.showProjectDetailsPage(
                                              $event,
                                              props.row["projetId"],
                                              props.row["id"]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(props.row[column.field])
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  "b-table-column",
                  column,
                  false
                )
              )
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }